import { Component, Input } from '@angular/core';
import { platformIconPathById } from '../../../../../app.constants';
import { InteractionReportItem } from '../../../../../../models/measure/report';
import {UserService} from '../../../../../services/user.service';
import {PdfExportService} from '../../../../../services/export-pdf/pdf-export.service';
import {InteractionReportComponent} from '../interaction-report.component';

@Component({
  selector: 'interaction-report-item',
  templateUrl: './interaction-report-item.component.html',
  styleUrls: ['./interaction-report-item.component.scss']
})
export class InteractionReportItemComponent {
  @Input() interactionPost: InteractionReportItem = new InteractionReportItem();
  @Input() index: number;
  // only use in pdf mode
  @Input() pageOrderNo: number;

  constructor(private pdfService: PdfExportService, private userService: UserService) { }

  public getPlatformIcon(platformId: number): string {
    return platformIconPathById[platformId].path;
  }

  onLoadedImage() {
    this.pdfService.updateNumberImageLoaded(`${InteractionReportComponent.COMPONENT_NAME}${this.pageOrderNo}`);
  }

  get activeAccount() {
    return this.userService.getCompanyId();
  }
}



// WEBPACK FOOTER //
// ./src/app/main/measure/contents/interaction-report/interaction-report-item/interaction-report-item.component.ts